// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag_information_card .tag_readmore_button:before{content:\"\";display:block;position:absolute;background:linear-gradient(0deg,#fff 2%,hsla(0,0%,100%,.536874) 47%,hsla(0,0%,100%,0));height:100px;width:100%;top:-100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
